/** Browser sedang online? (`navigator.onLine` false = pasti offline). */
export const isBrowserOnline = () => typeof navigator === 'undefined' || navigator.onLine !== false
